/**
 * Map profile-completeness field keys → staging Edit User section + form fields.
 * Pure — no React/DOM.
 */

/** @typedef {{ sectionId: string, formFields: string[], label: string }} CompletenessFocusTarget */

export const STAGING_EDIT_SECTION_IDS = {
  personal: 'sde-personal',
  education: 'sde-education',
  enrollment: 'sde-enrollment',
  marks: 'sde-marks',
};

/**
 * @type {Record<string, CompletenessFocusTarget>}
 */
const FOCUS_BY_KEY = {
  id: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['veStudentId'],
    label: 'VE Student ID',
  },
  fullName: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['firstName', 'lastName'],
    label: 'Full name',
  },
  emailAddress: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['email'],
    label: 'Email',
  },
  phoneNumber: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['mobile'],
    label: 'Phone',
  },
  gender: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['gender'],
    label: 'Gender',
  },
  currentAddress: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['address'],
    label: 'Current address',
  },
  permanentAddress: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['permanentAddress'],
    label: 'Permanent address',
  },
  currentLocation: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['address', 'cityId'],
    label: 'Current location',
  },
  pincode: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['pincode'],
    label: 'Pincode',
  },
  dob: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['dob'],
    label: 'Date of birth',
  },
  countryId: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['country'],
    label: 'Country',
  },
  stateId: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['state'],
    label: 'State',
  },
  cityId: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['cityId'],
    label: 'City',
  },
  parentsName: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['parentsName'],
    label: 'Parents name',
  },
  parentsPhone: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['parentsPhone'],
    label: 'Parents phone',
  },
  parentsEmail: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['parentsEmail'],
    label: 'Parents email',
  },
  domainId: {
    sectionId: STAGING_EDIT_SECTION_IDS.enrollment,
    formFields: ['domainId'],
    label: 'Domain',
  },
  profilePreference: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['profilePreference'],
    label: 'Profile preference',
  },
  heardFromId: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['heardFrom'],
    label: 'Heard from',
  },
  joiningKitReceived: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['joiningKitReceived'],
    label: 'Joining kit received',
  },
  linkedIn: {
    sectionId: STAGING_EDIT_SECTION_IDS.personal,
    formFields: ['linkedIn'],
    label: 'LinkedIn',
  },
  enrollment: {
    sectionId: STAGING_EDIT_SECTION_IDS.enrollment,
    formFields: ['batchId'],
    label: 'Enrollment / batch',
  },
  enrollmentCourse: {
    sectionId: STAGING_EDIT_SECTION_IDS.enrollment,
    formFields: ['courseId'],
    label: 'Course',
  },
  enrollmentMode: {
    sectionId: STAGING_EDIT_SECTION_IDS.enrollment,
    formFields: ['modeOfCourse'],
    label: 'Mode',
  },
  highestDegree: {
    sectionId: STAGING_EDIT_SECTION_IDS.education,
    formFields: ['degree'],
    label: 'Highest degree',
  },
  highestDegreeUniversity: {
    sectionId: STAGING_EDIT_SECTION_IDS.education,
    formFields: ['university', 'btechInstitute'],
    label: 'Highest degree university/college',
  },
  highestDegreeYear: {
    sectionId: STAGING_EDIT_SECTION_IDS.education,
    formFields: ['yearOfPassing', 'btechYear'],
    label: 'Highest degree year of passout',
  },
  highestDegreePercentage: {
    sectionId: STAGING_EDIT_SECTION_IDS.education,
    formFields: ['btechMarks'],
    label: 'Highest degree %/CGPA',
  },
};

/**
 * @param {string|null|undefined} completenessKey
 * @returns {CompletenessFocusTarget|null}
 */
export function resolveCompletenessFocusTarget(completenessKey) {
  if (!completenessKey) return null;
  return FOCUS_BY_KEY[completenessKey] || null;
}
